import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "_bgc--light _pa-3 _rounded--common" }
const _hoisted_2 = { class: "_bgc--light _rounded--common _flexcol _mt-4" }
const _hoisted_3 = { class: "_flex _jc-sb _pa-2" }
const _hoisted_4 = { class: "_tc--light" }
const _hoisted_5 = { "format-key": "0" }
const _hoisted_6 = {
  key: 2,
  class: "_tal"
}
const _hoisted_7 = { class: "_mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_number_field = _resolveComponent("number-field")
  const _component_product_grouped_option_field = _resolveComponent("product-grouped-option-field")
  const _component_product_basic_info = _resolveComponent("product-basic-info")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_product_set_item_details = _resolveComponent("product-set-item-details")
  const _component_product_option_field = _resolveComponent("product-option-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_modal_box = _resolveComponent("modal-box")

  return ($setup.productData)
    ? (_openBlock(), _createBlock(_component_modal_box, {
        key: 0,
        ref: "modal",
        title: $options.modalTitle,
        "is-visible": true,
        onAfterEnter: $options.onOpen
      }, {
        actions: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "gfu-link gfu-link--accent gfu-link--inline",
            onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
            "data-qa": "modal-button:Cancel"
          }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
          _createVNode(_component_tooltip, {
            enabled: $options.tooltipVisible,
            text: _ctx.tooltipContent,
            class: "_flexinline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                enabled: !$options.isDisabled,
                width: "wide",
                theme: "accent",
                onClick: _withModifiers($options.submit, ["prevent"]),
                "data-qa": "modal-button:Confirm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["enabled", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "text"])
        ]),
        default: _withCtx(() => [
          ($options.isStockLimitReached)
            ? (_openBlock(), _createBlock(_component_base_notificator, {
                key: 0,
                "can-close": false,
                type: "warning",
                class: "_my-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Product.ProductValidationLimitReachedTooltipText), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($options.isProductSet)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_product_basic_info, {
                    quantity: $options.formattedQuantity,
                    "product-data": $setup.productData,
                    "price-with-options": $setup.priceWithOptionModifiers,
                    "effective-price-with-options": $setup.effectivePriceWithOptionModifiers
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_number_field, {
                        modelValue: $data.model.quantity,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = $event => (($data.model.quantity) = $event)),
                          $options.recalculateSetItemQuantitiesWithDebounce
                        ],
                        "display-name": _ctx.Resources.YourPledge.CartTableQuantityHeader,
                        name: "model.quantity",
                        "text-align": "left",
                        min: 1,
                        maxlength: 5,
                        integer: true,
                        max: $options.quantityLimit,
                        disabled: $options.quantityChangeDisabled,
                        "data-qa": "modal-field:Quantity"
                      }, null, 8 /* PROPS */, ["modelValue", "display-name", "max", "disabled", "onUpdate:modelValue"]),
                      ($options.hasGroupedOptions && !$options.isProductSetItemsVisible)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.groupedOptions, (option) => {
                            return (_openBlock(), _createBlock(_component_product_grouped_option_field, {
                              key: option.text,
                              option: option,
                              "set-items": option.setItems,
                              "selected-option-value-id": option.selectedOptionValueId,
                              "currency-symbol": $options.currencySymbol,
                              "relative-factor-with-commission": $options.relativeFactorWithCommission,
                              disabled: $options.optionsChangeDisabled,
                              onChange: $options.onGroupedOptionsSelect
                            }, null, 8 /* PROPS */, ["option", "set-items", "selected-option-value-id", "currency-symbol", "relative-factor-with-commission", "disabled", "onChange"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["quantity", "product-data", "price-with-options", "effective-price-with-options"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, [
                      _createVNode(_component_localize, {
                        resource: _ctx.Resources.Product.RewardCardSetItemTableHeader
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString($options.pluralizedSetItemsCount), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"])
                    ]),
                    ($options.hasGroupedOptions)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!$options.isProductSetItemsVisible)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                class: "_tc--accent",
                                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onShowItems && $options.onShowItems(...args)), ["prevent"])),
                                "data-qa": "modal-button:ShowItems"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.AddToCartOptionsModalShowItemsInSetButton), 1 /* TEXT */),
                                _createVNode(_component_base_icon, { name: "angle-down" })
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($options.isProductSetItemsVisible)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.productSetItemsDetailsModel, (product) => {
                        return (_openBlock(), _createBlock(_component_product_set_item_details, _mergeProps({
                          key: `product-set-item-${product.uid}`
                        }, { ref_for: true }, product, {
                          onSplitProductItem: $options.onSplitProductItem,
                          onAmountInput: $options.onSplitAmountInput,
                          onRemoveProductItem: $options.onRemoveProductItem,
                          onOptionSelected: $options.setSelectedProductOption
                        }), null, 16 /* FULL_PROPS */, ["onSplitProductItem", "onAmountInput", "onRemoveProductItem", "onOptionSelected"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_product_basic_info, {
                  "product-data": $setup.productData,
                  "is-single-item": true,
                  quantity: $options.formattedQuantity,
                  "price-with-options": $setup.priceWithOptionModifiers,
                  "effective-price-with-options": $setup.effectivePriceWithOptionModifiers,
                  "is-discounted": $options.isDiscounted
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_number_field, {
                      modelValue: $data.model.quantity,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = $event => (($data.model.quantity) = $event)),
                        $options.recalculateSetItemQuantitiesWithDebounce
                      ],
                      "display-name": _ctx.Resources.YourPledge.CartTableQuantityHeader,
                      name: "model.quantity",
                      "text-align": "left",
                      min: 1,
                      maxlength: 5,
                      integer: true,
                      disabled: $options.quantityChangeDisabled,
                      max: $options.quantityLimit,
                      "data-qa": "modal-field:Quantity"
                    }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled", "max", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productData.options, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `product-item-option-${index}`,
                          "data-qa": "modal-field:ProductOption"
                        }, [
                          _createVNode(_component_product_option_field, {
                            option: option,
                            "selected-option-value-id": option.productOptionValueID,
                            "currency-symbol": $options.currencySymbol,
                            "relative-factor-with-commission": $options.relativeFactorWithCommission,
                            "label-class": "gfu-field__label--light",
                            disabled: $options.optionsChangeDisabled,
                            onChange: $options.setSelectedProductOption
                          }, null, 8 /* PROPS */, ["option", "selected-option-value-id", "currency-symbol", "relative-factor-with-commission", "disabled", "onChange"])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["product-data", "quantity", "price-with-options", "effective-price-with-options", "is-discounted"])
              ]))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "onAfterEnter"]))
    : _createCommentVNode("v-if", true)
}